import { atom } from 'jotai';

export const searchTabAtom = atom('전체');

export const searchKeyword = atom('');
